module.exports = __webpack_public_path__ + "static/media/trusted-company-logo.1cf0c9be.png";